import { Component, Input } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-triple-key',
  templateUrl: './userapi-triple-key.component.html'
})
export class UserApiTripleKeyComponent extends AbstractUserApiModalComponent {
  @Input() userApi: UserAPI;
}
